/* unplugin-vue-components disabled */import { render } from "./TokenManagePage.vue?vue&type=template&id=6066ef6e"
const script = {}

import exportComponent from "G:\\Projects\\Ornn\\node_modules\\.pnpm\\vue-loader@17.0.1_vue@3.4.0_webpack@5.75.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__